<template>
    <el-button type="text" plain  icon="el-icon-edit" v-on:click="clickEvent()" >{{ btnCon }}</el-button>
</template>
  
  <script>
  
  export default {
    name: 'table-update-button',
    props: {
      btnCon: {
            type: String,
            default: () => {
                return "修改"
            }
        },
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// TableUpdateButton.vue?6e98b8e8